/* ==========================================================================
   Print Online — homepage order cut-off countdown
   Mirrors the product-page timer (popreview2 upload-widget-cutoff.js):
   - wall-clock cut-off in a named zone (Australia/Sydney by default), so
     AEST/AEDT and viewers in other states are handled correctly
   - counts only from midnight to the cut-off on a weekday
   - ticks every second: "3h 42m 10s", then "4:37" inside the last hour
   - after the cut-off, on weekends and on listed public holidays the
     whole line is HIDDEN (no "ships next business day" fallback)

   Optional, before </head>:
   <script>window.PO_PUBLIC_HOLIDAYS = ['2026-12-25','2026-12-28'];</script>
   ========================================================================== */
(function () {
  'use strict';

  function partsIn(tz, date) {
    var dtf = new Intl.DateTimeFormat('en-GB', {
      timeZone: tz, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var o = {};
    dtf.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    var H = o.hour === '24' ? 0 : +o.hour;
    return { y: +o.year, m: +o.month, d: +o.day, H: H, M: +o.minute, S: +o.second };
  }

  function offsetMs(tz, date) {
    var p = partsIn(tz, date);
    var asUTC = Date.UTC(p.y, p.m - 1, p.d, p.H, p.M, p.S);
    return asUTC - (date.getTime() - date.getTime() % 1000);
  }

  function zonedTimestamp(tz, y, m, d, H, M) {
    var wall = Date.UTC(y, m - 1, d, H, M, 0);
    var ts = wall;
    for (var i = 0; i < 2; i++) ts = wall - offsetMs(tz, new Date(ts));
    return ts;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function isHoliday(p) {
    var list = window.PO_PUBLIC_HOLIDAYS || [];
    return list.indexOf(p.y + '-' + pad(p.m) + '-' + pad(p.d)) !== -1;
  }

  // Today's cut-off instant if a countdown is meaningful right now, else null.
  function target(tz, hour, minute, nowMs) {
    var p = partsIn(tz, new Date(nowMs));
    var dow = new Date(Date.UTC(p.y, p.m - 1, p.d)).getUTCDay();
    if (dow === 0 || dow === 6 || isHoliday(p)) return null;
    var ts = zonedTimestamp(tz, p.y, p.m, p.d, hour, minute);
    return ts > nowMs ? ts : null;
  }

  function formatLeft(ms) {
    var secs = Math.floor(ms / 1000);
    if (secs < 3600) return Math.floor(secs / 60) + ':' + pad(secs % 60);
    var hours = Math.floor(secs / 3600);
    var mins = Math.floor((secs % 3600) / 60);
    return hours + 'h ' + pad(mins) + 'm ' + pad(secs % 60) + 's';
  }

  function wrapOf(el) {
    return el.closest('[data-po-countdown-wrap]') || el;
  }

  // Each digit sits in its own fixed-width cell, so the line keeps the same
  // width every second and never re-wraps (which was resizing the mobile hero).
  function setTime(b, str) {
    b.textContent = '';
    for (var i = 0; i < str.length; i++) {
      var ch = str.charAt(i);
      if (ch >= '0' && ch <= '9') {
        var d = document.createElement('span');
        d.className = 'po-cd__d';
        d.textContent = ch;
        b.appendChild(d);
      } else {
        b.appendChild(document.createTextNode(ch));
      }
    }
  }

  function render(el) {
    var tz = (el.getAttribute('data-cutoff-tz') || '').trim() || 'Australia/Sydney';
    var hour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(hour)) hour = 14;
    var minute = parseInt(el.getAttribute('data-cutoff-minute'), 10) || 0;
    var before = el.getAttribute('data-before') || 'Order within {time}';

    var t;
    try { t = target(tz, hour, minute, Date.now()); }
    catch (e) { t = null; }

    if (t === null) {
      wrapOf(el).hidden = true;
      el.setAttribute('data-state', 'after');
      return;
    }

    var parts = before.split('{time}');
    el.textContent = '';
    el.appendChild(document.createTextNode(parts[0] || ''));
    var b = document.createElement('b');
    setTime(b, formatLeft(t - Date.now()));
    el.appendChild(b);
    el.appendChild(document.createTextNode(parts.slice(1).join('') || ''));
    el.setAttribute('data-state', 'before');
    wrapOf(el).hidden = false;
  }

  function tick() {
    var els = document.querySelectorAll('[data-po-countdown]');
    Array.prototype.forEach.call(els, render);
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { tick(); schedule(); }, 1000);
  }

  function init() { tick(); schedule(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', tick);
})();
